import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

const P = ({ children }) => <p className="text-ink/70 leading-[1.85] mb-4">{children}</p>;

const CONTENT = {
  "mentions-legales": {
    title: "Mentions légales",
    description: "Mentions légales du site rivierahostcollection.com — RIVIERA HOST COLLECTION, SAS au capital de 1 000 €, Le Cannet.",
    blocks: [
      { h: "Éditeur du site", ps: [
        "RIVIERA HOST COLLECTION — SAS (Société par actions simplifiée) au capital social de 1 000 €.",
        "SIREN : 108 829 573 — SIRET : 108 829 573 00014 — RCS Cannes.",
        "Siège social : 279 Rue Saint-Sauveur, 06110 Le Cannet, France.",
        "E-mail : contact@rivierahostcollection.com",
        "Directeur de la publication : Stéphane Tourette, Président.",
      ]},
      { h: "Hébergement", ps: [
        "Ce site est hébergé via la plateforme Emergent (emergent.sh), sur une infrastructure cloud sécurisée.",
      ]},
      { h: "Propriété intellectuelle", ps: [
        "L’ensemble des contenus du site (textes, photographies, éléments graphiques, marque « Riviera Host Collection ») est protégé. Toute reproduction ou réutilisation sans autorisation écrite préalable est interdite.",
      ]},
      { h: "Activité", ps: [
        "Riviera Host Collection exerce une activité de conciergerie et d’accompagnement de locations courte durée : optimisation des annonces, stratégie tarifaire, relation voyageurs, coordination et intendance. Riviera Host Collection n’est pas une agence immobilière et n’exerce aucune activité de gestion immobilière réglementée.",
      ]},
    ],
  },
  "confidentialite": {
    title: "Politique de confidentialité",
    description: "Politique de confidentialité de Riviera Host Collection : données collectées, finalités, durées de conservation et droits RGPD.",
    blocks: [
      { h: "Responsable du traitement", ps: [
        "RIVIERA HOST COLLECTION — SAS au capital de 1 000 €, 279 Rue Saint-Sauveur, 06110 Le Cannet, France. Contact : contact@rivierahostcollection.com.",
      ]},
      { h: "Données collectées et finalités", ps: [
        "Via nos formulaires de contact et d’estimation : prénom, nom, adresse e-mail, numéro de téléphone, ville et type du bien, nombre de chambres. Ces données servent exclusivement à répondre à votre demande, étudier le potentiel de votre bien et vous recontacter à ce sujet.",
        "Dans le cadre d’une réservation : dates de séjour, nombre de voyageurs et informations nécessaires au paiement. Le paiement est traité directement par notre prestataire de paiement sécurisé ; Riviera Host Collection ne conserve aucune donnée bancaire.",
      ]},
      { h: "Base légale", ps: [
        "Les traitements reposent sur l’exécution de mesures précontractuelles à votre demande (réponse aux demandes de contact et d’estimation), sur l’exécution du contrat (réservations) et sur notre intérêt légitime à assurer le suivi de nos échanges.",
      ]},
      { h: "Destinataires", ps: [
        "Vos données sont destinées à l’équipe de Riviera Host Collection. Pour les seules réservations, certaines informations techniques sont transmises à nos sous-traitants strictement nécessaires : prestataire de paiement (Stripe) et channel manager (Superhôte) pour la mise à jour des calendriers.",
        "Aucune donnée n’est vendue ni transmise à des tiers à des fins commerciales.",
      ]},
      { h: "Durée de conservation", ps: [
        "Demandes de contact et d’estimation : 3 ans à compter du dernier échange. Données liées aux réservations : durées légales applicables à la comptabilité et à la facturation.",
      ]},
      { h: "Vos droits", ps: [
        "Vous disposez d’un droit d’accès, de rectification, d’effacement, d’opposition, de limitation et, lorsque applicable, de portabilité de vos données. Pour les exercer : contact@rivierahostcollection.com.",
        "Vous pouvez également introduire une réclamation auprès de la CNIL (cnil.fr).",
      ]},
    ],
  },
  "cookies": {
    title: "Politique de cookies",
    description: "Politique de cookies de Riviera Host Collection : uniquement des cookies strictement nécessaires, aucun traceur publicitaire.",
    blocks: [
      { h: "Cookies utilisés sur ce site", ps: [
        "Ce site n’utilise aucun cookie publicitaire, aucun traceur de mesure d’audience et aucun pixel tiers. Aucun bandeau de consentement n’est donc nécessaire.",
        "Seuls des éléments strictement nécessaires au fonctionnement sont utilisés : un cookie technique d’authentification, réservé à l’espace d’administration du site, et la mémorisation de votre préférence de langue (FR/EN) dans le stockage local de votre navigateur.",
      ]},
      { h: "Gestion de vos préférences", ps: [
        "Vous pouvez à tout moment supprimer ces éléments depuis les paramètres de votre navigateur (effacement des cookies et des données de site).",
        "Pour toute question : contact@rivierahostcollection.com.",
      ]},
    ],
  },
};

export default function Legal({ slug }) {
  const c = CONTENT[slug] || CONTENT["mentions-legales"];
  return (
    <>
      <Seo title={c.title} description={c.description} path={`/${slug}`} />
      <PageHeader overline="Informations" title={c.title} />
      <section className="py-20 sm:py-28 max-w-3xl mx-auto px-5 sm:px-8" data-testid={`legal-${slug}`}>
        <Reveal>
          {c.blocks.map((b, i) => (
            <div key={i} className="mb-12">
              <h2 className="font-serif text-2xl sm:text-3xl mb-5">{b.h}</h2>
              {b.ps.map((p, j) => <P key={j}>{p}</P>)}
            </div>
          ))}
        </Reveal>
      </section>
    </>
  );
}
